import { takeEvery, put, call, fork, delay } from 'redux-saga/effects';
import { Client } from '../../utils/client';
import { HUBDATA_REFRESH, HUBDATA_FETCH, hubDataGetSuccess } from './actions';
import { appLogout } from '../../redux-root/actions';

export function* hubDataRefresh(action) {

  try {
    const data = yield call(Client.postData, `/api/v1/utility/hub-service-data`, action.payload, true);

    yield put(hubDataGetSuccess(data));
  } catch (error) {
    console.log(error);

    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}

export function* hubDataFetch(action) {
  const paramObject = Object.assign({}, action.payload);
  let params = '';

    Object.keys(paramObject).forEach(key => {
      if (params) {
        params += `&${key}=${paramObject[key]}`;
      } else {
        params += `${key}=${paramObject[key]}`;
      }
    });

  try {
    const data = yield call(Client.getData,`/api/v1/utility/hub-service-data?${params}`, true);

    yield put(hubDataGetSuccess(data));
  } catch (error) {
    console.log(error);

    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}


function* watchHubDataRefresh() {
  yield takeEvery(HUBDATA_REFRESH, hubDataRefresh);
}

function* watchHubDataFetch() {
  yield takeEvery(HUBDATA_FETCH, hubDataFetch);
}

export function* hubManagementSaga() {
  yield fork(watchHubDataRefresh);
  yield fork(watchHubDataFetch);
}
